import React from "react";

import Author from "author/components/Author/Author";
import Authorize from "components/Library/Authorize/Authorize";
import Events from "events/components/Events";
import SearchResults from "search/components/SearchResults";
import Subscription from "subscriptions/components/Subscription";
import Subscriptions from "subscriptions/components/Subscriptions";
import StoryPermalink from "dashboard/containers/StoryPermalink";
import SectionStream from "dashboard/containers/SectionStream";
import TagStream from "dashboard/containers/TagStream";
import NotFound from "dashboard/components/NotFound";

import { getStoriesStream } from "actions/storiesStream";
import { getNewsletter, populateSubscription } from "subscriptions/actions/subscriptions";
import { getRedirectPath } from "utils/server";
import asyncComponent from "utils/asyncComponent";
import {
  setSectionWithTag,
  getSection,
  setLastSeen,
} from "actions/navigation";
import { getAuthor } from "author/actions/author";
import { getSearchResults } from "actions/search";

import { URL_ID_REGEXP } from "config/constants";

// Todo: Remove Apollo prefix.
import ApolloSectionStream from "stream/containers/SectionStream";
import ApolloTagStream from "stream/containers/TagStream";
import ApolloPermalinkStream from "stream/containers/PermalinkStream";
import ApolloAuthorStream from "stream/containers/AuthorStream";
import ApolloSearchStream from "stream/containers/SearchStream";
import SmarterFaster from "stream/containers/SmarterFaster";

const oldPermalinkRoute = "/:slug([A-Za-z0-9-]+-)?:id([0-9]+).html";
const storyPermalinkRoute = `/:slug([A-Za-z0-9-]+?-)?:id${URL_ID_REGEXP}.html`;
const newsletterPermalinkRoute = `/newsletters/:subscription([A-Za-z0-9-]+)?-:newsletter${URL_ID_REGEXP}.html`;

const AsyncAbout = asyncComponent(() => import("about/components/About/About"));
const AsyncLegal = asyncComponent(() => import("legal/components/Legal/Legal"));
const AsyncUserSettings = asyncComponent(() => import("users/components/UserSettings/UserSettings"));
const AsyncSavedStories = asyncComponent(() => import("users/components/SavedStories/SavedStories"));

export const routes = [
  {
    path: "/",
    exact: true,
    render: (props) => {
      if (STREAM_REFACTOR) {
        return <ApolloSectionStream {...props} slug="top" />;
      } else {
        return <SectionStream {...props} slug="top" />;
      }
    },
    fetchData: (req, match, dispatch) => {
      const featuredReturnId = req.cookies.lastSeen || "";

      return STREAM_REFACTOR ? Promise.resolve() : Promise.all([
        dispatch(getSection("top")),
        dispatch(setLastSeen(featuredReturnId)),
        dispatch(getStoriesStream({ stream: "top", featured_return_id: featuredReturnId })),
      ]);
    },
  },
  {
    path: "/authors/:username",
    exact: true,
    component: STREAM_REFACTOR ? ApolloAuthorStream : Author,
    fetchData: (req, match, dispatch) => STREAM_REFACTOR ? Promise.resolve() : dispatch(getAuthor(match.params.username)),
  },
  {
    path: "/authorize",
    exact: true,
    component: Authorize,
  },
  {
    path: "/results",
    exact: true,
    component: STREAM_REFACTOR ? ApolloSearchStream : SearchResults,
    fetchData: (req, match, dispatch) => STREAM_REFACTOR ? Promise.resolve() : dispatch(getSearchResults(match.params.searchTerm)),
  },
  {
    path: "/legal",
    exact: true,
    component: AsyncLegal,
  },
  {
    path: "/about",
    exact: true,
    component: AsyncAbout,
  },
  {
    path: "/events",
    exact: true,
    component: Events,
  },
  {
    path: "/:section(smarter-faster)",
    exact: true,
    render: (props) => {
      if (STREAM_REFACTOR) {
        return <SmarterFaster {...props} slug={props.match.params.section} />;
      } else {
        return <SectionStream {...props} slug={props.match.params.section} />;
      }
    },
    fetchData: (req, match, dispatch) => {
      const featuredReturnId = req.cookies.lastSeen || "";

      return STREAM_REFACTOR ? Promise.resolve() : Promise.all([
        dispatch(getSection(match.params.section)),
        dispatch(setLastSeen(featuredReturnId)),
        dispatch(getStoriesStream({ stream: match.params.section, featured_return_id: featuredReturnId })),
      ]);
    },
  },
  {
    path: "/newsletters",
    exact: true,
    component: Subscriptions,
  },
  {
    path: newsletterPermalinkRoute,
    exact: true,
    component: Subscription,
    fetchData: (req, match, dispatch, context) => Promise.all([
      getRedirectPath(req, match.params.newsletter, context),
      dispatch(getNewsletter(match.params.newsletter)),
      dispatch(populateSubscription(match.params.subscription)),
    ]),
  },
  {
    path: "/newsletters/:subscription",
    exact: true,
    component: Subscription,
    fetchData: (req, match, dispatch) => dispatch(populateSubscription(match.params.subscription)),
  },
  {
    path: "/users/settings",
    exact: true,
    component: AsyncUserSettings,
  },
  {
    path: "/users/saved-stories",
    exact: true,
    component: AsyncSavedStories,
  },
  {
    path: "/tag/:tag",
    exact: true,
    component: STREAM_REFACTOR ? ApolloTagStream : TagStream,
    fetchData: (req, match, dispatch) => STREAM_REFACTOR ? Promise.resolve() : dispatch(setSectionWithTag(match.params.tag)),
  },
  {
    path: storyPermalinkRoute,
    component: STREAM_REFACTOR ? ApolloPermalinkStream : StoryPermalink,
    fetchData: (req, match, dispatch, context) => {
      if (req.query.preview || req.query.revision) return Promise.resolve();
      return Promise.all([
        getRedirectPath(req, match.params.id, context),
        STREAM_REFACTOR ? Promise.resolve() : dispatch(getStoriesStream({ story: match.params.id, stream: req.query.stream })),
      ]);
    },
  },
  {
    path: oldPermalinkRoute,
    render: () => { null },
    fetchData: (req, match, dispatch, context) => getRedirectPath(req, match.params.id, context),
  },
  {
    path: "/community/:user",
    fetchData: (req, match, dispatch, context) => {
      context.status = 301;
      context.path = `/authors/${match.params.user}`;
      return Promise.resolve();
    },
  },
  {
    path: "/:section([a-zA-Z-]+)",
    render: (props) => {
      if (STREAM_REFACTOR) {
        return <ApolloSectionStream {...props} slug={props.match.params.section} />;
      } else {
        return <SectionStream {...props} slug={props.match.params.section} />;
      }
    },
    fetchData: (req, match, dispatch) => {
      const featuredReturnId = req.cookies.lastSeen || "";

      return STREAM_REFACTOR ? Promise.resolve() : Promise.all([
        dispatch(getSection(match.params.section)),
        dispatch(setLastSeen(featuredReturnId)),
        dispatch(getStoriesStream({ stream: match.params.section, featured_return_id: featuredReturnId })),
      ]);
    },
    exact: true,
  },
  // 404 fallback route
  {
    path: "/*",
    render: ({ staticContext }) => {
      if (staticContext) staticContext.status = 404;
      return <NotFound />;
    },
  },
];
